import styled, { css } from 'styled-components';
import { colorUtils, layout, media, remCalc } from '@prisjakt/ui-base';
import BadgeComponent from '../badge';

import { SUB_TITLE_SIZE } from '../../constants';

const CHARITY_LOGO_WIDTH = '73px';
const WINNERSBOX_MIN_HEIGHT = '150px';

export const SubTitle = styled.h4`
  font-size: ${remCalc(SUB_TITLE_SIZE)};
`;

export const WinnersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: ${layout.spacing.small};
  }

  ${media.smallOnly`
    @supports (display: grid) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const WinningShop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Badge = styled(BadgeComponent)``;

export const TitleWrapper = styled.div``;

export const PreText = styled.p`
  color: ${p => p.theme.text.tertiary};
  margin: 0;
`;

export const CategoryTitle = styled.h4`
  font-size: 18px;
`;

export const WinnerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const WinnerInfoText = styled.h5`
  font-weight: 100;
  font-size: ${layout.fontSizes.base.desktop.rem};
`;

type WinnersBoxProps = {
  fullwidth: boolean;
};

export const WinnerBox = styled.div<WinnersBoxProps>(
  props => css`
    display: flex;
    background: ${colorUtils.setRgbaAlpha(props.theme.header.bg, '0.1')};
    padding: ${layout.spacing.small};
    border-radius: 8px;

    ${props.fullwidth
      ? css`
          ${media.mediumUp`
            @supports (display: grid) {
              display: grid;
              grid-template-columns: 1fr auto;
              padding-right: ${layout.spacing.large};
              grid-column: auto / span 4;
            }

            ${Content} {
              flex-direction: row;
            }

            ${CategoryTitle} {
              font-size: 32px;
            }

            ${WinnerInfoText} {
              font-size: 22px;
            }
          `}

          ${media.smallOnly`
          flex-direction: column;
          
            ${CategoryTitle} {
              font-size: 22px;
            }

            ${Badge} {
              margin: 0;
              margin-bottom: ${layout.spacing.xSmall};
            }

            ${TitleWrapper} {
              text-align: center;
            }
          `}
        `
      : css`
          flex-direction: column;
          justify-content: space-between;
          min-height: ${WINNERSBOX_MIN_HEIGHT};

          ${Content} {
            margin-bottom: ${layout.spacing.xSmall};
          }

          ${Badge} {
            margin: 0;
            margin-bottom: ${layout.spacing.xSmall};
          }

          ${TitleWrapper} {
            text-align: center;
          }

          ${WinningShop} {
            margin-bottom: ${layout.spacing.xSmall};
          }
        `}
  `
);

export const Conscious = styled.div`
  display: flex;
  align-items: center;

  ${media.smallOnly`    
    margin-bottom: ${layout.spacing.xSmall};
  `}
`;

export const ConsciousLogo = styled.img`
  max-width: ${CHARITY_LOGO_WIDTH};
`;

export const ConsciousText = styled.p`
  color: ${p => p.theme.text.tertiary};
  margin: 0;
  margin-right: ${layout.spacing.xSmall};
`;
